






import { Component, Vue, Inject } from 'vue-property-decorator';
import SNavMenu from './SNavMenu.vue';

@Component
export default class SSubmenu extends Vue {
  @Inject({ from: 'sNavMenu' }) public sNavMenu!: SNavMenu;
}
